import { DataSource } from '~/Api/DataSource';

export class ComparativePriceProduct {
	public constructor(public readonly id: string, public readonly dataSource: DataSource) {}
}
